// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1Mzvz","label":"Radio_label__3RtVF","checkMark":"Radio_checkMark__3q6ai","disabled":"Radio_disabled__3ct6w"};